<app-side-menu>
  <div class="b2b-contracts-item-view-container">
    <!-- Loading State -->
    <app-loading [show]="isLoading" message="Carregando item..."></app-loading>

    <!-- Content -->
    <div *ngIf="!isLoading && item" class="view-content">
      <!-- Header -->
      <div class="header">
        <div class="title-section">
          <button class="btn-back" (click)="navigateBack()">
            <i class="fas fa-arrow-left"></i>
          </button>
          <div class="title-info">
            <h1>
              <i class="fas fa-list me-2"></i>
              Pedido {{ item.itemNumber || item.ItemNumber || 'N/A' }}
            </h1>
            <p *ngIf="contractNumber">
              Contrato: {{ contractNumber }} - {{ contractName }}
            </p>
          </div>
        </div>
        <div class="action-buttons">
          <button type="button" class="btn btn-primary" (click)="navigateToEdit()">
            <i class="fas fa-edit me-2"></i>
            Editar pedido
          </button>
          <button class="btn btn-secondary" (click)="navigateBack()">
            <i class="fas fa-arrow-left me-2"></i>
            Voltar
          </button>
        </div>
      </div>

      <!-- Informações do Item -->
      <div class="card mb-4">
        <div class="card-header text-white">
          <h3>
            <i class="fas fa-info-circle me-2"></i>
            Informações do Pedido
          </h3>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label">Número do Pedido</label>
              <p class="form-control-plaintext">{{ item.itemNumber || item.ItemNumber || 'N/A' }}</p>
            </div>
            <div class="col-md-6">
              <label class="form-label">Tipo de Moto</label>
              <p class="form-control-plaintext">{{ item.motorcycleType || item.MotorcycleType || 'N/A' }}</p>
            </div>
            <div class="col-md-4">
              <label class="form-label">Quantidade</label>
              <p class="form-control-plaintext">{{ item.quantity || item.Quantity || 0 }}</p>
            </div>
            <div class="col-md-4">
              <label class="form-label">Valor Unitário</label>
              <p class="form-control-plaintext mb-0">
                <app-sensitive-currency [displayOnly]="true" [amount]="item.unitValue || item.UnitValue || 0"></app-sensitive-currency>
              </p>
            </div>
            <div class="col-md-4">
              <label class="form-label">Status</label>
              <p class="form-control-plaintext">
                <span class="badge" [ngClass]="getStatusClass(item.status || item.Status)">
                  {{ getStatusLabel(item.status || item.Status) }}
                </span>
              </p>
            </div>
            <div class="col-md-6">
              <label class="form-label">Tipo de Pagamento</label>
              <p class="form-control-plaintext">{{ item.paymentType || item.PaymentType || 'N/A' }}</p>
            </div>
            <div class="col-md-6">
              <label class="form-label">Número de Parcelas</label>
              <p class="form-control-plaintext">{{ item.installmentCount || item.InstallmentCount || 'N/A' }}</p>
            </div>
            <div class="col-md-6">
              <label class="form-label">Estado</label>
              <p class="form-control-plaintext">{{ item.state || item.State || 'N/A' }}</p>
            </div>
            <div class="col-md-6">
              <label class="form-label">Cidade</label>
              <p class="form-control-plaintext">{{ item.city || item.City || 'N/A' }}</p>
            </div>
            <div class="col-md-6">
              <label class="form-label">Tipo de Contrato</label>
              <p class="form-control-plaintext">{{ item.contractType || item.ContractType || 'N/A' }}</p>
            </div>
            <div class="col-md-6">
              <label class="form-label">Tipo de Entrega</label>
              <p class="form-control-plaintext">{{ item.deliveryType || item.DeliveryType || 'N/A' }}</p>
            </div>
            <div class="col-md-6">
              <label class="form-label">Rua / número</label>
              <p class="form-control-plaintext">{{ item.pole || item.Pole || 'N/A' }}</p>
            </div>
            <div class="col-md-6">
              <label class="form-label">Data de Entrega</label>
              <p class="form-control-plaintext">{{ formatDate(item.deliveryDate || item.DeliveryDate) }}</p>
            </div>
            <div class="col-md-6">
              <label class="form-label">Data de Devolução</label>
              <p class="form-control-plaintext">{{ formatDate(item.returnDate || item.ReturnDate) }}</p>
            </div>
            <div class="col-md-6">
              <label class="form-label">Data de Retirada (cliente)</label>
              <p class="form-control-plaintext">{{ formatDate(item.customerPickupDate || item.CustomerPickupDate) }}</p>
            </div>
            <div class="col-md-12">
              <label class="form-label">Descrição de Acessórios</label>
              <p class="form-control-plaintext">{{ item.accessoriesDescription || item.AccessoriesDescription || 'N/A' }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Veículos do pedido -->
      <div class="card mb-4">
        <div class="card-header text-white">
          <h3>
            <i class="fas fa-motorcycle me-2"></i>
            Motos deste pedido ({{ getVehicleSnapshots().length }})
          </h3>
          <p class="mb-0 small text-white-50 opacity-90">
            Cada linha é um veículo <strong>deste pedido</strong>. Use Visualizar para ver rastreador e demais dados da moto.
          </p>
        </div>
        <div class="card-body">
          <div *ngIf="getVehicleSnapshots().length > 0" class="b2b-item-vehicles-wrap">
            <div class="b2b-item-vehicles-toolbar mb-3">
              <div class="b2b-item-vehicles-search-wrap">
                <i class="fas fa-search b2b-item-vehicles-search-icon"></i>
                <input
                  type="search"
                  class="form-control b2b-item-vehicles-search"
                  placeholder="Pesquisar placa, modelo, marca ou rastreador..."
                  [(ngModel)]="vehicleSearchTerm"
                  autocomplete="off" />
              </div>
            </div>

            <div *ngIf="filteredVehicleRows.length === 0" class="alert alert-light border mb-0">
              Nenhum veículo corresponde à pesquisa.
            </div>

            <div class="table-responsive b2b-item-vehicles-table-wrap" *ngIf="filteredVehicleRows.length > 0">
              <table class="table table-hover table-sm align-middle mb-0 b2b-item-vehicles-table">
                <thead class="table-light">
                  <tr>
                    <th>Placa</th>
                    <th>Modelo</th>
                    <th>Ano</th>
                    <th>Cor</th>
                    <th>Marca</th>
                    <th>RENAVAM</th>
                    <th>Chassi</th>
                    <th>KM atual</th>
                    <th>Status op.</th>
                    <th>Rastreador</th>
                    <th>Condutor</th>
                    <th class="text-center">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let v of filteredVehicleRows">
                    <td>{{ v.plate }}</td>
                    <td>{{ v.model }}</td>
                    <td>{{ v.year }}</td>
                    <td>{{ v.color }}</td>
                    <td>{{ v.brand }}</td>
                    <td>{{ v.renavam }}</td>
                    <td class="text-monospace small">{{ v.chassis }}</td>
                    <td>{{ formatKm(v.currentKm) }}</td>
                    <td>
                      <span class="badge bg-secondary" *ngIf="v.operationalStatus">{{ v.operationalStatus }}</span>
                      <span class="text-muted" *ngIf="!v.operationalStatus">—</span>
                    </td>
                    <td>{{ formatTracker(v) }}</td>
                    <td class="small">
                      <span [class.text-muted]="!v.hasDriver">{{ v.driverDisplay }}</span>
                    </td>
                    <td class="text-center text-nowrap b2b-item-vehicles-actions">
                      <button
                        type="button"
                        class="b2b-vh-icon-btn b2b-vh-view"
                        title="Visualizar veículo"
                        (click)="clickVisualizarVeiculo(v)">
                        <i class="fas fa-eye" aria-hidden="true"></i>
                        <span class="visually-hidden">Visualizar veículo</span>
                      </button>
                      <button
                        type="button"
                        class="b2b-vh-icon-btn b2b-vh-trocar"
                        title="Trocar veículo"
                        [disabled]="v.id == null"
                        (click)="clickTrocarVeiculo(v)">
                        <i class="fas fa-exchange-alt" aria-hidden="true"></i>
                        <span class="visually-hidden">Trocar veículo</span>
                      </button>
                      <button
                        *ngIf="v.hasDriver && v.id != null"
                        type="button"
                        class="b2b-vh-icon-btn b2b-vh-desvincular"
                        title="Desvincular condutor desta moto (neste pedido)"
                        (click)="clickDesvincularCondutor(v)">
                        <i class="fas fa-unlink" aria-hidden="true"></i>
                        <span class="visually-hidden">Desvincular condutor</span>
                      </button>
                      <button
                        type="button"
                        class="b2b-vh-icon-btn b2b-vh-devolver"
                        title="Devolver"
                        (click)="clickDevolverVeiculo(v)">
                        <i class="fas fa-undo" aria-hidden="true"></i>
                        <span class="visually-hidden">Devolver</span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div *ngIf="getVehicleSnapshots().length === 0" class="empty-state text-center py-5">
            <i class="fas fa-motorcycle fa-3x text-muted mb-3"></i>
            <h4>Nenhum veículo encontrado</h4>
            <p class="text-muted">Este pedido não possui veículos associados.</p>
          </div>
        </div>
      </div>

      <!-- Modais de troca e devolução (neste pedido) -->
      <!-- Modal: substituição de veículo -->
      <app-modal
        [isOpen]="showSubstituirModal"
        [title]="'Troca de veículo (substituição)'"
        [size]="'lg'"
        (close)="closeSubstituirModal()">
      <div class="b2b-vehicle-modal" *ngIf="selectedVehicleRow">
        <p class="small text-muted mb-3">
          Substituição no pedido — veículo atual: <strong>{{ placaAtualSubstituicao }}</strong>.
          <span class="d-block mt-1">Isto <strong>não</strong> é devolução; para devolução use o botão <strong>Devolver</strong> na tabela.</span>
        </p>
        <form [formGroup]="substituirForm" (ngSubmit)="submitSubstituir()">
          <div class="row g-2 mb-2">
            <div class="col-md-8">
              <label class="form-label">Placa do substituto <span class="text-danger">*</span></label>
              <div class="input-group">
                <input type="text" class="form-control" formControlName="plate" placeholder="ABC-1D23" />
                <button type="button" class="btn btn-outline-primary" (click)="searchVehicleByPlate()" [disabled]="isSearchingVehicle">
                  <i class="fas" [ngClass]="isSearchingVehicle ? 'fa-spinner fa-spin' : 'fa-search'"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="row g-2">
            <div class="col-md-4">
              <label class="form-label">Marca</label>
              <input type="text" class="form-control" formControlName="brand" />
            </div>
            <div class="col-md-4">
              <label class="form-label">Modelo <span class="text-danger">*</span></label>
              <input type="text" class="form-control" formControlName="model" />
            </div>
            <div class="col-md-4">
              <label class="form-label">Ano <span class="text-danger">*</span></label>
              <input type="number" class="form-control" formControlName="year" />
            </div>
            <div class="col-md-4">
              <label class="form-label">Cor</label>
              <input type="text" class="form-control" formControlName="color" />
            </div>
            <div class="col-md-4">
              <label class="form-label">RENAVAM</label>
              <input type="text" class="form-control" formControlName="renavam" />
            </div>
            <div class="col-md-4">
              <label class="form-label">Chassi</label>
              <input type="text" class="form-control" formControlName="chassis" />
            </div>
            <div class="col-md-4">
              <label class="form-label">KM atual <span class="text-danger">*</span></label>
              <input type="number" class="form-control" formControlName="currentKm" min="0" />
            </div>
            <div class="col-12">
              <label class="form-label">Observações de vistoria</label>
              <textarea class="form-control" rows="2" formControlName="inspectionNotes"></textarea>
            </div>
            <div class="col-12">
              <label class="form-label">Observação interna (opcional)</label>
              <input type="text" class="form-control" formControlName="observacao" />
            </div>
          </div>
          <div class="d-flex justify-content-end gap-2 mt-3">
            <button type="button" class="btn btn-secondary" (click)="closeSubstituirModal()">Cancelar</button>
            <button type="submit" class="btn btn-primary" [disabled]="isSavingSubstituir">
              <span *ngIf="isSavingSubstituir" class="spinner-border spinner-border-sm me-1"></span>
              Confirmar troca
            </button>
          </div>
        </form>
      </div>
    </app-modal>

    <!-- Modal: devolução — body somente motivo -->
    <app-modal
      [isOpen]="showDevolverModal"
      [title]="'Devolver veículo'"
      [size]="'md'"
      (close)="closeDevolverModal()">
      <div class="b2b-vehicle-modal" *ngIf="contractId && itemId">
        <form [formGroup]="devolverForm" (ngSubmit)="submitDevolver()">
          <div class="mb-3">
            <label class="form-label">Motivo <span class="text-danger">*</span></label>
            <textarea
              class="form-control"
              rows="3"
              formControlName="motivo"
              placeholder="Ex.: Fim do período contratado."></textarea>
          </div>
          <div class="d-flex justify-content-end gap-2">
            <button type="button" class="btn btn-secondary" (click)="closeDevolverModal()">Cancelar</button>
            <button type="submit" class="btn btn-danger" [disabled]="isSavingDevolver">
              <span *ngIf="isSavingDevolver" class="spinner-border spinner-border-sm me-1"></span>
              Confirmar devolução
            </button>
          </div>
        </form>
      </div>
    </app-modal>

    <!-- Modal: desvincular condutor — neste item / linha da moto -->
    <app-modal
      [isOpen]="showDesvincularModal"
      [title]="'Desvincular condutor (esta moto neste item)'"
      [size]="'md'"
      (close)="closeDesvincularModal()">
      <div class="b2b-vehicle-modal" *ngIf="contractId && itemId && vehicleRowForDesvincular">
        <p class="small text-muted mb-3">
          Item <strong>{{ item?.itemNumber || item?.ItemNumber || itemId }}</strong> —
          placa <strong>{{ vehicleRowForDesvincular.plate }}</strong>.
        </p>
        <form [formGroup]="desvincularForm" (ngSubmit)="submitDesvincular()">
          <div class="mb-3">
            <label class="form-label">Motivo <span class="text-danger">*</span></label>
            <select
              class="form-control"
              formControlName="motivo"
              [class.is-invalid]="desvincularForm.get('motivo')?.invalid && desvincularForm.get('motivo')?.touched">
              <option value="">Selecione o motivo</option>
              <option *ngFor="let opt of desvincularMotivoOptions" [value]="opt.value">{{ opt.label }}</option>
            </select>
            <div class="invalid-feedback" *ngIf="desvincularForm.get('motivo')?.invalid && desvincularForm.get('motivo')?.touched">
              Selecione o motivo
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label">Data/hora (opcional)</label>
            <input type="datetime-local" class="form-control" formControlName="returnDate" />
          </div>
          <div class="d-flex justify-content-end gap-2">
            <button type="button" class="btn btn-secondary" (click)="closeDesvincularModal()" [disabled]="isSavingDesvincular">
              Cancelar
            </button>
            <button type="submit" class="btn btn-warning text-dark" [disabled]="isSavingDesvincular">
              <span *ngIf="isSavingDesvincular" class="spinner-border spinner-border-sm me-1"></span>
              Desvincular
            </button>
          </div>
        </form>
      </div>
    </app-modal>

    <!-- Modal 2: descrever motivo quando selecionar Outro -->
    <app-modal
      [isOpen]="showDesvincularOutroModal"
      [title]="'Descreva o motivo'"
      [size]="'md'"
      (close)="closeDesvincularOutroModal()">
      <div class="b2b-vehicle-modal" *ngIf="vehicleRowForDesvincular">
        <p class="small text-muted mb-3">
          Placa <strong>{{ vehicleRowForDesvincular.plate }}</strong> — informe o motivo da desvinculação.
        </p>
        <form [formGroup]="desvincularOutroForm" (ngSubmit)="submitDesvincularOutro()">
          <div class="mb-3">
            <label class="form-label">Motivo <span class="text-danger">*</span></label>
            <textarea
              class="form-control"
              formControlName="detalhe"
              rows="4"
              [attr.maxlength]="500"
              [placeholder]="'Descreva o motivo (mínimo ' + desvincularOutroMinLength + ' caracteres)'"
              [class.is-invalid]="desvincularOutroForm.get('detalhe')?.invalid && desvincularOutroForm.get('detalhe')?.touched">
            </textarea>
            <div class="invalid-feedback" *ngIf="desvincularOutroForm.get('detalhe')?.invalid && desvincularOutroForm.get('detalhe')?.touched">
              Informe o motivo com pelo menos {{ desvincularOutroMinLength }} caracteres.
            </div>
          </div>
          <div class="d-flex justify-content-end gap-2">
            <button type="button" class="btn btn-secondary" (click)="closeDesvincularOutroModal()" [disabled]="isSavingDesvincular">
              Voltar
            </button>
            <button type="submit" class="btn btn-warning text-dark" [disabled]="isSavingDesvincular">
              <span *ngIf="isSavingDesvincular" class="spinner-border spinner-border-sm me-1"></span>
              Confirmar desvínculo
            </button>
          </div>
        </form>
      </div>
    </app-modal>
    </div>
  </div>
</app-side-menu>
